import {createContext} from "react";
import {UserData} from "../../api/staff";
export const StaffListContext = createContext<UserData[]>([]);
